import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { Box } from "@mui/material";
import { CountryService } from "../../../services/common/CountryService";
import { IAppState } from "../../../store/reducers";
import { useNavigateToLogout } from "../../../common/Common";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

interface IWSIBClassInfoSetupFieldsPanel {
	wsibCLassParentDDL: any;
	setIsLoading: (value: boolean) => void;
	onProvinceSelectionChangeHandler: (params: any) => void;
}
const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});
export const WSIBClassInfoSetupFieldsPanel: FC<
	IWSIBClassInfoSetupFieldsPanel
> = ({ wsibCLassParentDDL, setIsLoading, onProvinceSelectionChangeHandler }) => {
	// const canadaProvinces = useSelector((state: IAppState) => state.countryAndProvincesInfo.canadaProvinces);
	const { data: countryDDL } = useGetCountryDDL();
	const navigateToLogout = useNavigateToLogout();
	const [provinceDDL, setProvinceDDL] = useState<any>(undefined);
	useEffect(() => {
		if (countryDDL && Array.isArray(countryDDL)) {
			const canada = countryDDL.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				(async () => {
					try {
						setIsLoading(true)
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setProvinceDDL(response);
					} catch (err) { } finally { setIsLoading(false) }
				})();
			}
		}
	}, [countryDDL])
	return (
		<Box>
			{countryDDL && provinceDDL && <EnhancedDropDownRHFWithLabel
				testId={"canada-provinces"}
				selectName={"provinceId"}
				items={provinceDDL ?? []}
				label={"Province"}
				onSelectionChangeHandler={onProvinceSelectionChangeHandler}
			/>}
			<RHookFormTextFieldWithLabel
				label="Short Name"
				id="shortName"
				testId={`shortName`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="Label"
				id="label"
				testId={`label`}
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedTextAreaFieldRHF
				label="Descirption"
				id="description"
				testId={`description`}
			/>

			<EnhancedDropDownRHFWithLabel
				testId={"parent-ddl"}
				selectName={"parentId"}
				// items={wsibCLassParentDDL && Array.isArray(wsibCLassParentDDL) ? wsibCLassParentDDL : []}
				items={wsibCLassParentDDL ?? []}
				label={"Parent"}
			// selectedItem={"All"}
			/>
			{/* <RHookFormNumberFieldWithLabel id={"rate"} testId={"rate"} label={"Rate"} />
			<RHookFormDatePicker label={"Effective Date"} testId={"effective-date"} name={"effectiveDate"} />
			<RHookFormDatePicker label={"End Date"} testId={"end-date"} name={"endDate"} /> */}
		</Box>
	);
};
